module.exports = __webpack_public_path__ + "static/stories-hero-tiny-375eb8b284bb27b4ad234645630aaefa.png";